export default __webpack_public_path__ + "static/media/0000..0000.14e7a0b3.png";